// src/services/stripe.js
// Stripe.js loader. Payments are DIRECT charges on the carrier's connected account, so
// Stripe.js must be initialised with that account (stripeAccount) for each payment.
import { loadStripe } from '@stripe/stripe-js';

const PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
const cache = {};

// Returns a (cached) Stripe promise for the given connected account. Without an account
// it falls back to the platform (legacy destination charges).
export const getStripe = (stripeAccount) => {
  const key = stripeAccount || '__platform__';
  if (!cache[key]) {
    cache[key] = stripeAccount
      ? loadStripe(PUBLISHABLE_KEY, { stripeAccount })
      : loadStripe(PUBLISHABLE_KEY);
  }
  return cache[key];
};
